export function getMenuItemByName(name, menu) {
  const item = menu.filter((newItem) => {
    return newItem.title === name;
  });

  return item.pop();
}

export function getMenuItemById(id, menu) {
  const item = menu.filter((newItem) => {
    return newItem.id === id;
  });

  return item.pop();
}

export function getMenuItemChilds(parent, menu) {
  return menu.filter((newItem) => {
    return newItem.parent === parent;
  });
}

export function getMenuTopLevelParent(item, menu) {
  let parent = item.parent;

  while (parent !== "") {
    item = getMenuItemById(item.parent, menu);
    parent = item.parent;
  }

  return item;
}

export function getNodeChilds(name, menu) {
  const parent = getMenuItemByName(name, menu);
  return parent ? getMenuItemChilds(parent.id, menu) : [];
}

export function getNodeTheme(node, menu) {
  const menuItem = getMenuItemByName(node.title, menu);

  if (typeof menuItem === "undefined") {
    return "primary";
  }

  const topLevelParent = getMenuTopLevelParent(menuItem, menu);

  return topLevelParent.options.attributes["data-theme"] || "primary";
}
